"use client";

import { useEffect, useState } from "react";
import type { AffiliateItem } from "@/lib/affiliate";
import { AffiliateCarousel } from "@/components/affiliate-carousel";

// Heading + grid of random affiliate picks, shown at the bottom of a file
// preview. Fetches its own data lazily (only mounts once a file is previewed),
// so it never blocks the landing page's initial render. Renders nothing until
// items are available.
export function AffiliatePicks({ count = 4 }: { count?: number }) {
  const [items, setItems] = useState<AffiliateItem[]>([]);

  useEffect(() => {
    let active = true;
    fetch("/api/affiliate-items")
      .then((res) => (res.ok ? res.json() : []))
      .then((data) => {
        if (active && Array.isArray(data)) setItems(data);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="space-y-4 border-t pt-8">
      <div className="space-y-1">
        <h2 className="text-lg font-semibold">FitConvert&apos;s picks</h2>
        <p className="text-sm text-muted-foreground">
          Hand-picked fitness gear we think you&apos;ll like.
        </p>
      </div>
      <AffiliateCarousel items={items} count={count} />
    </section>
  );
}
